import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import ConfirmationDialog from '../../../components/ui/ConfirmationDialog';

const BulkOperationsBar = ({ selectedCount, onBulkDelete, onBulkStatusUpdate, onClearSelection }) => {
  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showStatusConfirm, setShowStatusConfirm] = useState(false);
  const [emailSending, setEmailSending] = useState(false);

  const statusOptions = [
    { value: 'Available', label: 'Available' },
    { value: 'On Job', label: 'On Job' },
    { value: 'Off Duty', label: 'Off Duty' }
  ];

  const handleBulkDelete = async () => {
    setShowDeleteConfirm(true);
  };

  const confirmBulkDelete = async () => {
    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 500));
    onBulkDelete();
    setLoading(false);
    setShowDeleteConfirm(false);
  };

  const handleBulkStatusUpdate = async () => {
    if (!selectedStatus) {
      alert('Please select a status');
      return;
    }
    setShowStatusConfirm(true);
  };

  const confirmBulkStatusUpdate = async () => {
    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 500));
    onBulkStatusUpdate(selectedStatus);
    setLoading(false);
    setShowStatusUpdate(false);
    setShowStatusConfirm(false);
    setSelectedStatus('');
  };

  return (
    <>
      <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
            <Icon name="CheckSquare" size={20} color="white" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-foreground">
              {selectedCount} {selectedCount === 1 ? 'person' : 'people'} selected
            </h3>
            <p className="text-sm text-muted-foreground">
              Choose an action to apply to selected personnel
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {!showStatusUpdate ? (
            <>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setShowStatusUpdate(true)}
                iconName="RefreshCw"
                iconPosition="left"
                disabled={loading}
              >
                Update Status
              </Button>
              <Button
                variant="destructive"
                size="sm"
                onClick={handleBulkDelete}
                iconName="Trash2"
                iconPosition="left"
                loading={loading}
                disabled={loading}
              >
                Delete Selected
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={onClearSelection}
                disabled={loading}
              >
                Clear Selection
              </Button>
            </>
          ) : (
            <div className="flex items-center gap-2">
              <Select
                options={statusOptions}
                value={selectedStatus}
                onChange={setSelectedStatus}
                placeholder="Select new status"
              />
              <Button
                variant="default"
                size="sm"
                onClick={handleBulkStatusUpdate}
                loading={loading}
                disabled={loading || !selectedStatus}
              >
                Apply
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  setShowStatusUpdate(false);
                  setSelectedStatus('');
                }}
                disabled={loading}
              >
                Cancel
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>

    <ConfirmationDialog
        isOpen={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={confirmBulkDelete}
        title="Delete Personnel"
        message={`Are you sure you want to delete ${selectedCount} ${selectedCount === 1 ? 'person' : 'people'}? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        variant="destructive"
        loading={loading}
        icon="Trash2"
      />

      <ConfirmationDialog
        isOpen={showStatusConfirm}
        onClose={() => setShowStatusConfirm(false)}
        onConfirm={confirmBulkStatusUpdate}
        title="Update Status"
        message={`Are you sure you want to update the status of ${selectedCount} ${selectedCount === 1 ? 'person' : 'people'} to "${selectedStatus}"?`}
        confirmText="Update"
        cancelText="Cancel"
        variant="default"
        loading={loading}
        icon="RefreshCw"
      />
    </>
  );
};

export default BulkOperationsBar;